import { Typography } from "@chemaxon/design-system/typography";

const FormSectionTitle = props => (
  <Typography variant="subtitle1" component="h3" {...props} />
);

export default FormSectionTitle;
